import { MouseEvent, useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';

import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';

/**
 * Retorna o ícone de status do step.
 */
function ConfigPedidoMenuIcon({ fgSaved, fgDirty, isButton = false }: { fgSaved: boolean; fgDirty: boolean; isButton?: boolean }) {
    if (fgSaved && !fgDirty) {
        return (
            <Tooltip title="Salvo">
                <CheckCircleIcon sx={{ mr: 1.5 }} fontSize="small" color={isButton ? 'inherit' : 'primary'} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Não salvo">
            <ErrorIcon sx={{ mr: 1.5 }} fontSize="small" color={isButton ? 'inherit' : 'error'} />
        </Tooltip>
    );
}

export function ConfigPedidoMenu() {
    const { activeStep, requestStepChange, stepList } = useConfigPedidoStepContext();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLButtonElement>): void => setAnchorEl(event.currentTarget);
    const handleClose = (): void => setAnchorEl(null);

    return (
        <>
            <Button
                variant="contained"
                onClick={handleClick}
                endIcon={<MenuRoundedIcon />}
                sx={{
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    fontSize: 14,
                    minWidth: 264,
                    justifyContent: 'flex-start',
                    pl: 1.5,
                    flex: { xs: 1, md: 0 },
                }}
            >
                <ConfigPedidoMenuIcon fgSaved={activeStep.fgSaved} fgDirty={activeStep.fgDirty} isButton />

                <span style={{ flex: 1, textAlign: 'start', fontSize: 14 }}>{activeStep.dsConfigPedidoStep}</span>
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            width: anchorEl?.getBoundingClientRect().width || 264,
                        },
                    },
                }}
            >
                {stepList.map((item) => {
                    const { dsConfigPedidoStep, fgSaved, fgDirty, fgDisabled } = item;
                    const isSelected = activeStep.dsChaveConfigPedidoStep === item.dsChaveConfigPedidoStep;

                    return (
                        <MenuItem
                            key={item.dsChaveConfigPedidoStep}
                            selected={isSelected}
                            disabled={fgDisabled}
                            sx={{ pl: 1.5 }}
                            onClick={() => {
                                requestStepChange(item);

                                handleClose();
                            }}
                        >
                            <ConfigPedidoMenuIcon fgSaved={fgSaved} fgDirty={fgDirty} />

                            {dsConfigPedidoStep}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
